export const prize = (
  <div className="">
    <p style={{fontSize:"1.7rem"}}>
      <strong>Volkswagen ID.4 NEW PRO SO 77KWH</strong>
    </p>

  
 <div>
<strong>Kerevärv</strong> C2C2 Moonstone Gray <br />
<strong>Sisu:</strong> BLACK-GRAY/BLACK/BLA <br /><br />
<strong>Funktsionaalsus ja muu varustus</strong>
<ul><li>•	Raadio <i>Ready 2 Discover Pro </i>
  <ul>
<li>o	32,7 cm puuteekraan</li>
<li>o	navigatsioonisüsteemi <i>Discover Pro</i> aktiveerimise valmidus </li>
</ul></li>

<li>•	Lamineeritud turvaklaasiga, soojus- ja heliisolatsiooniga esiklaas Rohelise soojusisolatsiooniga klaasid külg- ja tagaakendel</li>
<li>•	Elektriliselt reguleeritavad ja kokkuklapitavad soojendusega välispeeglid </li>
<li>•	Võtmeta avamis- ja käivitussüsteem <i>Keyless Advanced</i> </li>
<li>•	Automaatkliimaseade <i>Air Care Climatronic </i></li>
<li>•	Tagurduskaamera</li>
<li>•	Vihmaandur</li>
<li>•	Esitulede automaatne lülitus</li>
<li>•	Ümbruse valgustus</li>
<li>•	Valgustusega ukselingisüvendid</li>
<li>•	<i>App-Connect</i> (sisaldab <i>App-Connect Wireless</i>i) </li>
<li>•	Sõidurežiimi valik</li>
<li>•	Parkimisandurid ees ja taga</li>
<li>•	2 USB-C pesa ees</li>
<li>•	Pagasiruumi põrand</li>
<li>•	Elektromehaaniline kiirustundlik roolivõimendus </li>
<li>•	6+1 kõlarit</li>
<li>•	Digitaalne raadio DAB+</li>
<li>•	<i>Bluetooth</i> mobiiltelefoniliides</li>
<li>•	Dünaamiline liiklusmärkide kuvamine</li>
<li>•	<i>We Connect</i> ja <i>We Connect Plus</i> valmidus </li>
</ul>
<strong>Välimus</strong>
<ul>
<li>•	Plekkveljed 8J x 19, rehvid 235/55 R19 ees, 255/50 R19 taga </li>
<li>•	Mattmustad katuseliistud </li>
<li>•	Mustad katusereelingud LED-esituled</li>
<li>•	Kombineeritud LED-tagatuled </li>
</ul>
<strong>Sisemus </strong>
<ul>
<li>•	Matrix kangast tekstiilistmekatted</li>
<li>•	Reguleeritava kõrgusega juhiiste</li>
<li>•	Käetoed mõlemal esiistmel</li>
<li>•	Kahe topsihoidjaga keskkonsool ees</li>
<li>•	3 tagaistet, asümmeetriliselt eraldi kokkuklapitav tagaistme seljatugi </li>
<li>•	Puutetundlike nuppudega multifunktsionaalne rool </li>
<li>•	Teabe- ja meelelahutussüsteemi ekraani ja juhtnuppude mustad raamid </li>
<li>•	Roostevabast terasest <i>Play</i> ja <i>Pause</i> disainiga pedaalid</li>
<li>•	10 värvist koosneva valikuga sisemine miljöövalgustus</li>
<li>•	Valgustusega meikimispeeglid päikesevarjudes </li>
</ul>
<strong>Turvalisus </strong>
<ul>
<li>•	Vargusvastane alarmsüsteem siseruumianduri ja pukseerimiskaitsega </li>
<li>•	Eesmised turvapadjad koos kõrvalistuja turvapadja deaktiveerimisega </li>
<li>•	Turvakardinad ja eesmised külgturvapadjad, keskmine turvapadi </li>
<li>•	Reahoidmisabiline <i>Lane Assist</i> </li>
<li>•	Otsasõidu eest hoiatav süsteem <i>Front Assist</i> koos autonoomse hädapidurdussüsteemiga</li>
<li>•	Jalakäijate ja jalgratturite jälgimise süsteem</li>
<li>•	Pikivaheregulaatoriga püsikiirushoidik ACC</li>
<li>•	Proaktiivne reisijate kaitse süsteem </li>
<li>•	Keeramisel vastutuleva liikluse korral pidurdamise ja ümberpõike abi </li>
<li>•	Täiustatud juhi tähelepanelikkuse ja väsimuse tuvastamine</li>
<li>•	<i>eCall</i> hädaabikõnesüsteem</li>
<li>•	Elektrooniline mootoriheli </li>
<li>•	Car2X funktsioon</li>
<li>•	Kaudne rehvirõhu kontrollsüsteem</li>
<li>•	ISOFIX kinnituskohad (kinnitused laste turvatoolidele välimistel tagumistel istmetel ja eesmisel kõrvalistmel) </li>
<li>•	Rehviparanduskomplekt: 12-voldine kompressor ja rehviparandusvaht, tööriistakomplekt</li>
<li>•	Kiirusepiiraja </li>
</ul>
<strong>Aku ja laadimine </strong>
<ul>
<li>•	82 kWh (bruto) ja 77 kWh (neto) mahutavusega liitium-ioon-kõrgepingeaku </li>
<li>•	CCS kombineeritud laadimise pistikupesa, mis sobib nii vahelduvvooluga (AC) kui kiireks alalisvooluga (DC) laadimiseks </li>
<li>•	Tavalisest pistikupesast laadimise kaabel</li>
<li>•	Laadimiskaabel <i>Mode 3, Type 2</i>, 16 A</li>
<li>•	Vahelduvvooluga (AC) laadimisvõimsus 11 kW*</li>
<li>•	Alalisvooluga (DC) laadimisvõimsus 125 kW (alalisvooluga laadimisjaamadest) </li>
</ul>
<strong>Garantii </strong>
<ul>
<li>•	Garantii 5 aastat või 100 000 km (esimesed kaks aastat läbisõidupiiranguta) </li>
<li>•	Kõrgepingeakule - 8 aastat või 160 000 km</li>
<li>•	Digitaalne kasutusjuhend </li>
</ul>
<strong>Lisavarustus </strong>
<ul>
<li>•	Eestikeelne kasutusjuhend</li>
<li>•	Tekstiilist põrandamatid ees ja taga</li>
<li>•	Kujunduspakett 
  <ul>
  <li>o	maatriks-LED-esituled, udutuli</li>
  <li>o	täiustatud dünaamiline kaugtulede automaatlülitus <i>Dynamic Light Assist</i> - 3D LED-tagatuled dünaamiliste suunatuledega</li>
  <li>o	valgustusega iluvõre esitulede vahel</li>
  <li>o	valgusisolatsiooniga klaasid külg- ja tagaakendel </li>
  </ul>
  </li>
<li>•	<i>Illuminated front grill</i> </li>
<li>•	Teabe- ja meelelahutuspakett <ul>
  <li>o	25,4 cm puuteekraaniga navigatsioonisüsteem <i>Discover Pro</i> </li>
  <li>o	Mobiiltelefoniliides <i>Comfort</i> koos induktsioonlaadimisega </li>
  </ul></li> 
<li>•	PAV Mugavuspakett 
  <ul><li>o	soojendusega esiistmed</li>
      <li>o	automaatse soojendusega pesurid ees</li>
      <li>o	nahkkatte ja soojendusega multifunktsionaalne rool koos puutetundlike nuppudega</li>
      <li>o	traatideta soojendusega, infrapunakiirgust peegeldav esiklaas</li>
      <li>o	kahetsooniline automaatkliimaseade <i>Climatronic</i></li>
      <li>o	2 USB-C laadimispesa taga keskkonsoolis</li>
      <li>o	liugkaane ja valgustusega panipaigaga, kahe topsihoidjaga keskkonsool</li>
      <li>o	aknapesuvedeliku taseme näidik </li>
  </ul></li>
  </ul>
ainult koos PAD, PAF, PAG või PAH-ga ainult koos PAA või PAC-ga <br /><br />
Ark registreerimine 
Ettevalmistus ja ohutuskomplekt 


 </div>




  </div>
);
